import React from 'react';
import PropTypes from 'prop-types';
import './CustomTooltip.scss';

function CustomTooltip({ active, payload, label }) {
  if (!active || !payload || payload.length === 0) return null;
  return (
    <div className="custom-tooltip">
      <p className="tooltip-label">Transaction Count:</p>
      {payload.map((entry) => (
        <p key={`item-${entry.name}-${label}`} className="value">{`${entry.name} :   ${
          entry.payload[entry.name].count
        }`}</p>
      ))}
    </div>
  );
}

CustomTooltip.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number
    })
  ),
  label: PropTypes.string
};
CustomTooltip.defaultProps = {
  active: false,
  payload: [],
  label: ''
};

export default CustomTooltip;
